import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import RenderingTile from 'components/molecules/RenderingTile';
import CallOutValueWithChange from 'components/molecules/CallOutValueWithChange';
import ObjectiveVisibilityContainer from 'containers/dashboards/social/ObjectiveVisibilityContainer';
import ConversionsExpandContainer from 'containers/dashboards/social/ConversionsExpandContainer';
import { LAYERTHREE } from 'constants/layers';

class ConversionsModule extends Component {
    render() {
        const { objective, layer = LAYERTHREE } = this.props;
        const stub = `l${layer}-social`;
        const { callouts, actions, campaigns } = this.props.module;
        const hasCalloutData = get(callouts, 'params.hasData', false);
        const calloutWindow = get(callouts, 'params.timeRanges.previous.windowSize', false);
        const completeData = get(callouts, 'params.completeData', false);
        const calloutsData = hasCalloutData ? callouts.data : {};

        return (
            <ObjectiveVisibilityContainer objective={objective} actions={actions}
                campaigns={campaigns} layer={layer} expandContainer={ConversionsExpandContainer}>
                {/* Call Outs */}
                <Row>
                    <Col xs={12} md={4}>
                        {hasCalloutData ? (
                            <CallOutValueWithChange
                                exportName={`${stub}-conversions-callouts-impressions`}
                                title="Impressions"
                                type="impressions"
                                format='0,0'
                                data={{
                                    value: calloutsData.current_impressions,
                                    change: Math.round(
                                        calloutsData.impressions_per_delta, 0),
                                    completeData,
                                    sparkline: calloutsData.sparkline,
                                    calloutWindow
                                }}
                                animateDuration={2000} />
                        ) : (
                            <RenderingTile height='180px' />
                        )}
                    </Col>
                    <Col xs={12} md={4}>
                        {hasCalloutData ? (
                            <CallOutValueWithChange
                                exportName={`${stub}-conversions-callouts-conversions`}
                                title="Conversions"
                                type="conversions"
                                format='0,0'
                                data={{
                                    value: calloutsData.current_conversions,
                                    change: Math.round(
                                        calloutsData.conversions_per_delta, 0),
                                    completeData,
                                    sparkline: calloutsData.sparkline,
                                    calloutWindow
                                }}
                                animateDuration={2000} />
                        ) : (
                            <RenderingTile height='180px' />
                        )}
                    </Col>
                    <Col xs={12} md={4}>
                        {hasCalloutData ? (
                            <CallOutValueWithChange
                                exportName={`${stub}-conversions-callouts-conversion-rate`}
                                title="Conversion Rate"
                                type="conversion_rate"
                                data={{
                                    value: calloutsData.current_conversion_rate,
                                    change: Math.round(calloutsData.conversion_rate_per_delta, 0),
                                    completeData,
                                    sparkline: calloutsData.sparkline,
                                    calloutWindow
                                }}
                                format='0.00%'
                                animateDuration={2000} />
                        ) : (
                            <RenderingTile height='180px' />
                        )}
                    </Col>
                </Row>

            </ObjectiveVisibilityContainer>
        );
    }
}

ConversionsModule.propTypes = {
    module: PropTypes.shape({
        callouts: PropTypes.object,
    }).isRequired
};

export default ConversionsModule;



// WEBPACK FOOTER //
// ./src/components/organisms/social/ConversionsModule.js